import type { SectionImages } from 'types/api/images';
import type { VodInSection } from 'types/api/products/vod';
import type { BannerInSection } from 'types/api/products/banner';
import type { ChannelInSection } from 'types/api/products/channels';
import type { ProgramInSection } from 'types/api/products/program';

export enum PageLabel {
	Main = 'MAIN_WEB',
	Vod = 'VOD_WEB',
	Series = 'SERIES_WEB',
	Kids = 'KIDS_WEB',
	Start = 'START_WEB',
	Olympics = 'OLYMPICS_WEB'
}

export enum SectionType {
	LiveEpg = 'live_epg',
	Banner = 'banner',
	BannerLg = 'banner_lg',
	Virtual = 'virtual',
	Carousel = 'carousel',
	Promoted = 'promoted',
	Normal = 'normal',
	Catchup = 'catchup'
}

export type Section = {
	active: number;
	created_at: string;
	id: string;
	images: SectionImages;
	label: string;
	live_epg: boolean;
	main_limit: number;
	name: string;
	order: number;
	type: SectionType;
	updated_at: string;
	user_context: boolean;
};

export type SectionContentElement = VodInSection | ChannelInSection | BannerInSection | ProgramInSection;

export type SectionContent = SectionContentElement[];

export type SectionContentResponse = {
	total: number;
	data: SectionContent;
};
